import { MenuItem } from "@mui/material";
import { TextFieldForm } from "@styleguide";
import { type Control, useWatch } from "react-hook-form";
import { missedReason } from "../logics/constants";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";

export interface IModalActionFormMissedReasonProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormMissedReason = ({ control }: IModalActionFormMissedReasonProps) => {
  const status = useWatch({
    control,
    name: "status",
  });

  if (status !== "missed") {
    return null;
  }
  return (
    <TextFieldForm control={control} name="missedReason" label="Raison *" size="small" select>
      {missedReason.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextFieldForm>
  );
};
